module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "404 not-found text-center"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("404")]), _vm._v(" "), _c('h3', {
    staticClass: "_subtitle"
  }, [_vm._v("No page found")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('@/assets/turntable.gif'),
      "width": "40%",
      "alt": "turntable vinyle gif"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-action"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require('@/assets/arrow_back_alt.svg'),
      "width": "28",
      "alt": "arrow back"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "black--text",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Back To Yousound")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8e5fb46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 1850
// module chunks = 180